import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i5 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { environment } from 'environment-configurations';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import * as i2$1 from 'file-upload-library';
import * as i3 from 'ngx-toastr';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from 'primeng/calendar';
import * as i8 from 'primeng/table';
import * as i9 from 'primeng/api';
import * as i10 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class BasicPositionEditDetailsService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getPositionDetails(pageFormId, formDataId) {
        return this.http.get(`/vd/formBuilder/get/${pageFormId}/${formDataId}/details`).pipe(
        //  return this.http.get(`/vd/formBuilder/requisition/${requisitionId}/details`).pipe(
        map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    deleteFile(id) {
        return this.http.delete(`/vd/formBuilder/formDataDocs/delete/${id}`).pipe(map((data) => {
            return data;
        }));
    }
    setFormDataId(formDataId) {
        this.formDataId = formDataId;
    }
    getFormDataId() {
        return this.formDataId;
    }
}
BasicPositionEditDetailsService.ɵfac = function BasicPositionEditDetailsService_Factory(t) { return new (t || BasicPositionEditDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
BasicPositionEditDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: BasicPositionEditDetailsService, factory: BasicPositionEditDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicPositionEditDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

function BasicPositionEditDetailsComponent_div_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "p", 7);
    i0.ɵɵtext(2, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 28);
    i0.ɵɵelementEnd();
} }
function BasicPositionEditDetailsComponent_div_51_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "p", 7);
    i0.ɵɵtext(2, "Earliest Hire Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-calendar", 29);
    i0.ɵɵlistener("onSelect", function BasicPositionEditDetailsComponent_div_51_Template_p_calendar_onSelect_3_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.dateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControlName", "hireDate")("showIcon", true);
} }
function BasicPositionEditDetailsComponent_div_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵtext(3, "Skills Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "textarea", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BasicPositionEditDetailsComponent_div_74_ng_template_7_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "span", 41);
    i0.ɵɵlistener("click", function BasicPositionEditDetailsComponent_div_74_ng_template_7_div_7_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r13); const loadData_r9 = i0.ɵɵnextContext().$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.openDoc(loadData_r9); });
    i0.ɵɵelementStart(3, "mat-icon", 42);
    i0.ɵɵtext(4, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "i", 43);
    i0.ɵɵlistener("click", function BasicPositionEditDetailsComponent_div_74_ng_template_7_div_7_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r13); const loadData_r9 = i0.ɵɵnextContext().$implicit; const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.download(loadData_r9); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "i", 44);
    i0.ɵɵlistener("click", function BasicPositionEditDetailsComponent_div_74_ng_template_7_div_7_Template_i_click_8_listener() { i0.ɵɵrestoreView(_r13); const loadData_r9 = i0.ɵɵnextContext().$implicit; const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.deleteDoc(loadData_r9); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BasicPositionEditDetailsComponent_div_74_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "p", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 37);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtemplate(7, BasicPositionEditDetailsComponent_div_74_ng_template_7_div_7_Template, 9, 0, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loadData_r9 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r9 == null ? null : loadData_r9.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Uploaded on ", loadData_r9 == null ? null : loadData_r9.fileUploadDate, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", loadData_r9.fileName !== null);
} }
function BasicPositionEditDetailsComponent_div_74_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
function BasicPositionEditDetailsComponent_div_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Uploaded Files");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵelementStart(6, "p-table", 33);
    i0.ɵɵtemplate(7, BasicPositionEditDetailsComponent_div_74_ng_template_7_Template, 8, 3, "ng-template", 34);
    i0.ɵɵtemplate(8, BasicPositionEditDetailsComponent_div_74_ng_template_8_Template, 3, 1, "ng-template", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r3.positionDetails == null ? null : ctx_r3.positionDetails.file)("resizableColumns", true);
} }
function BasicPositionEditDetailsComponent_div_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Assign Request");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "p", 7);
    i0.ɵɵtext(7, "Recruiters");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class BasicPositionEditDetailsComponent {
    constructor(basicPositionEditDetailsService, uploadService, toastr, dialog, cdRef, fb) {
        this.basicPositionEditDetailsService = basicPositionEditDetailsService;
        this.uploadService = uploadService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.fb = fb;
        this.positionDetails = [];
        this.observableSubscription$ = new Subject();
        this.group = new FormGroup({});
        this.allowedRoles = ['Recruiter', 'Recruitment manager'];
    }
    ngOnInit() {
        var _a;
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
        this.fbRole = 'fbRole' in sessionStorage ? sessionStorage.getItem('fbRole') : null;
        this.showContainer = this.allowedRoles.map(role => role.toLowerCase()).includes((_a = this.fbRole) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        this.basicDetailsForm = this.fb.group({
            department: new FormControl(null),
            location: new FormControl(null),
            positionTitle: new FormControl(null),
            experienceFrom: new FormControl(null),
            experienceTo: new FormControl(null),
            openPositions: new FormControl(null),
            workingModel: new FormControl(null),
            jobType: new FormControl(null),
            shiftTime: new FormControl(null),
            qualification: new FormControl(null),
            client: new FormControl(null),
            hireDate: new FormControl(null),
            salaryRangeFrom: new FormControl(null),
            salaryRangeTo: new FormControl(null),
            salary: new FormControl(null),
            rolesAndResp: new FormControl(null),
            skillsRequired: new FormControl(null),
            recruiters: new FormControl(null)
        });
        this.getpositionDetails();
        this.group.addControl(this.inputParams.name, this.basicDetailsForm);
        if (this.inputParams.value) {
            //this.basicDetailsForm.patchValue(this.inputParams.value);
            this.basicDetailsForm.updateValueAndValidity();
        }
    }
    getpositionDetails() {
        const formDataId = this.basicPositionEditDetailsService.getFormDataId();
        this.formDataId = 'formDataId' in sessionStorage ? parseInt(sessionStorage.getItem('formDataId')) : formDataId;
        this.pageFormId = 'currentPageFormId' in sessionStorage ? parseInt(sessionStorage.getItem('currentPageFormId')) : null;
        this.basicPositionEditDetailsService.setFormDataId(this.formDataId);
        if (this.formDataId && this.pageFormId) {
            this.basicPositionEditDetailsService.getPositionDetails(this.pageFormId, this.formDataId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
                this.positionDetails = (response === null || response === void 0 ? void 0 : response.data) || null;
                if (this.positionDetails) {
                    const hireDate = this.positionDetails.earlierHiredateString ? moment((_a = this.positionDetails) === null || _a === void 0 ? void 0 : _a.earlierHiredateString, 'DD-MMM-YYYY').format('MM/DD/YYYY') : null;
                    this.basicDetailsForm.patchValue({
                        department: (_c = (_b = this.positionDetails) === null || _b === void 0 ? void 0 : _b.department) === null || _c === void 0 ? void 0 : _c.departmentName,
                        location: (_d = this.positionDetails) === null || _d === void 0 ? void 0 : _d.city,
                        positionTitle: (_f = (_e = this.positionDetails) === null || _e === void 0 ? void 0 : _e.jobPosition) === null || _f === void 0 ? void 0 : _f.name,
                        experienceFrom: (_g = this.positionDetails) === null || _g === void 0 ? void 0 : _g.expFromYears,
                        experienceTo: (_h = this.positionDetails) === null || _h === void 0 ? void 0 : _h.expToYears,
                        openPositions: (_j = this.positionDetails) === null || _j === void 0 ? void 0 : _j.noOfOpenPositions,
                        workingModel: (_l = (_k = this.positionDetails) === null || _k === void 0 ? void 0 : _k.workMode) === null || _l === void 0 ? void 0 : _l.workMode,
                        jobType: (_o = (_m = this.positionDetails) === null || _m === void 0 ? void 0 : _m.employmentType) === null || _o === void 0 ? void 0 : _o.employmentTypeName,
                        shiftTime: (_q = (_p = this.positionDetails) === null || _p === void 0 ? void 0 : _p.shift) === null || _q === void 0 ? void 0 : _q.shiftName,
                        qualification: (_s = (_r = this.positionDetails) === null || _r === void 0 ? void 0 : _r.qualification) === null || _s === void 0 ? void 0 : _s.qualification,
                        client: (_u = (_t = this.positionDetails) === null || _t === void 0 ? void 0 : _t.taClientId) === null || _u === void 0 ? void 0 : _u.clientCompanyName,
                        hireDate: hireDate,
                        salaryRangeFrom: (_v = this.positionDetails) === null || _v === void 0 ? void 0 : _v.salaryRangeFrom,
                        salaryRangeTo: (_w = this.positionDetails) === null || _w === void 0 ? void 0 : _w.salaryRangeTo,
                        salary: (_x = this.positionDetails) === null || _x === void 0 ? void 0 : _x.salaryCurrency,
                        rolesAndResp: (_z = (_y = this.positionDetails) === null || _y === void 0 ? void 0 : _y.rolesAndResposibilityObj) === null || _z === void 0 ? void 0 : _z.rolesAndResponsibility,
                        skillsRequired: (_0 = this.positionDetails) === null || _0 === void 0 ? void 0 : _0.skillsRequired,
                        recruiters: (_1 = this.positionDetails) === null || _1 === void 0 ? void 0 : _1.assignRequest
                    });
                }
                //sessionStorage.removeItem('formDataId');
            });
        }
        // this.cdRef.detectChanges();
    }
    dateChange(event) {
        const formattedDate = moment(event).format('MM/DD/YYYY');
        this.basicDetailsForm.patchValue({ hireDate: formattedDate });
    }
    openDoc(item) {
        var _a;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl;
        const docPath = (_a = item.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9);
        window.open(`${baseUrl}/${docPath}`, '_blank');
    }
    download(file) {
        var _a, _b, _c;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl + '/';
        this.uploadService.downloadDocuments(baseUrl + ((_a = file.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9)), this.isFBUser ? (_b = file.fileLocation) === null || _b === void 0 ? void 0 : _b.split('/').slice(-1)[0] : (_c = file.fileLocation) === null || _c === void 0 ? void 0 : _c.substring(9));
    }
    deleteDoc(item) {
        const title = "Confirm";
        const message = "Do you wish to Delete the File?";
        if (item) {
            this.dialogueInitializer(event, title, message)
                .afterClosed()
                .subscribe((result) => {
                if (result) {
                    this.basicPositionEditDetailsService.deleteFile(item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                        if (response.status === 200) {
                            this.toastr.success(response.message, 'Success');
                            this.getpositionDetails();
                        }
                    });
                }
            });
        }
    }
    dialogueInitializer(event, title, message) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: "400px",
            data: {
                update: { title, message },
                buttons: ["Cancel", "Delete"],
            },
        });
        return dialogRef;
    }
}
BasicPositionEditDetailsComponent.ɵfac = function BasicPositionEditDetailsComponent_Factory(t) { return new (t || BasicPositionEditDetailsComponent)(i0.ɵɵdirectiveInject(BasicPositionEditDetailsService), i0.ɵɵdirectiveInject(i2$1.FileUploadLibraryService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i5.FormBuilder)); };
BasicPositionEditDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: BasicPositionEditDetailsComponent, selectors: [["lib-basic-position-edit-details"]], inputs: { inputParams: "inputParams", group: "group" }, decls: 76, vars: 8, consts: [[3, "formGroup"], [1, "row", 3, "formGroupName"], [1, "col-12", 3, "formGroup"], [1, "details"], [1, "col-12", "positionHeading"], [1, "row", "mt-2"], [1, "col-3"], [1, "label-cls"], ["type", "text", "formControlName", "department", 1, "im-input", "form-control"], ["type", "text", "formControlName", "location", 1, "im-input", "form-control"], [1, "col-2"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "positionTitle", 1, "im-input"], ["type", "text", "formControlName", "experienceFrom", 1, "im-input", "form-control"], ["type", "text", "formControlName", "experienceTo", 1, "im-input", "form-control"], ["type", "text", "formControlName", "openPositions", 1, "im-input", "form-control"], ["type", "text", "formControlName", "workingModel", 1, "im-input", "form-control"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "jobType", 1, "im-input"], ["type", "text", "formControlName", "shiftTime", 1, "im-input", "form-control"], ["type", "text", "formControlName", "qualification", 1, "im-input", "form-control"], ["class", "col-3", 4, "ngIf"], [1, "col-6"], [1, "labelHeading", "headlbl"], ["rows", "2", "formControlName", "rolesAndResp", 1, "textAreaWidth", "form-control"], ["class", "row mt-2", 4, "ngIf"], ["type", "text", "formControlName", "salaryRangeFrom", 1, "im-input", "form-control"], ["type", "text", "formControlName", "salaryRangeTo", 1, "im-input", "form-control"], ["type", "text", "formControlName", "salary", 1, "im-input", "form-control"], [4, "ngIf"], ["type", "text", "formControlName", "client", 1, "im-input", "form-control"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "formControlName", "showIcon", "onSelect"], ["rows", "2", "formControlName", "skillsRequired", 1, "textAreaWidth", "form-control"], [1, "positionDetailsSection"], [1, "row", "mt-2", "p-0", "pb-3"], ["styleClass", "p-datatable-gridlines", 3, "value", "resizableColumns"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [1, "label-light"], [1, "label-light", "label-sub"], ["class", "row file-icons", 4, "ngIf"], [1, "row", "file-icons"], [1, "mr-2", "padding0"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons"], ["title", "Download", 1, "fa", "fa-download", "pr-2", "icn", 3, "click"], ["title", "Delete", 1, "fa", "fa-trash", "icn", 3, "click"], ["type", "text", "formControlName", "recruiters", 1, "im-input", "form-control"]], template: function BasicPositionEditDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "h5");
        i0.ɵɵtext(6, "Basic Position Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "p", 7);
        i0.ɵɵtext(10, "Department");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "input", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵelementStart(13, "p", 7);
        i0.ɵɵtext(14, "Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "input", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 10);
        i0.ɵɵelementStart(17, "p", 7);
        i0.ɵɵtext(18, "Position Title");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "input", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 10);
        i0.ɵɵelementStart(21, "p", 7);
        i0.ɵɵtext(22, "Experience From");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 10);
        i0.ɵɵelementStart(25, "p", 7);
        i0.ɵɵtext(26, "Experience To");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(27, "input", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 5);
        i0.ɵɵelementStart(29, "div", 6);
        i0.ɵɵelementStart(30, "p", 7);
        i0.ɵɵtext(31, "No. of open positions");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 6);
        i0.ɵɵelementStart(34, "p", 7);
        i0.ɵɵtext(35, "Working Model");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(36, "input", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 6);
        i0.ɵɵelementStart(38, "p", 7);
        i0.ɵɵtext(39, "Job Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(40, "input", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 6);
        i0.ɵɵelementStart(42, "p", 7);
        i0.ɵɵtext(43, "Shift Time");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(44, "input", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 5);
        i0.ɵɵelementStart(46, "div", 6);
        i0.ɵɵelementStart(47, "p", 7);
        i0.ɵɵtext(48, "Qualification");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(49, "input", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(50, BasicPositionEditDetailsComponent_div_50_Template, 4, 0, "div", 19);
        i0.ɵɵtemplate(51, BasicPositionEditDetailsComponent_div_51_Template, 4, 2, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "div", 5);
        i0.ɵɵelementStart(53, "div", 20);
        i0.ɵɵelementStart(54, "div", 21);
        i0.ɵɵtext(55, "Job Roles & Responsibilities");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(56, "textarea", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(57, BasicPositionEditDetailsComponent_div_57_Template, 5, 0, "div", 23);
        i0.ɵɵelementStart(58, "div", 4);
        i0.ɵɵelementStart(59, "h5");
        i0.ɵɵtext(60, "Salary Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "div", 5);
        i0.ɵɵelementStart(62, "div", 6);
        i0.ɵɵelementStart(63, "p", 7);
        i0.ɵɵtext(64, "Salary From");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(65, "input", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "div", 6);
        i0.ɵɵelementStart(67, "p", 7);
        i0.ɵɵtext(68, "Salary To");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(69, "input", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(70, "div", 6);
        i0.ɵɵelementStart(71, "p", 7);
        i0.ɵɵtext(72, "Salary");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(73, "input", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(74, BasicPositionEditDetailsComponent_div_74_Template, 9, 2, "div", 27);
        i0.ɵɵtemplate(75, BasicPositionEditDetailsComponent_div_75_Template, 9, 0, "div", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.inputParams == null ? null : ctx.inputParams.name);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.basicDetailsForm);
        i0.ɵɵadvance(48);
        i0.ɵɵproperty("ngIf", ctx.showContainer);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContainer);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.showContainer);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngIf", ctx.showContainer);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContainer);
    } }, directives: [i5.ɵangular_packages_forms_forms_ba, i5.NgControlStatusGroup, i5.FormGroupDirective, i5.FormGroupName, i5.DefaultValueAccessor, i5.NgControlStatus, i5.FormControlName, i5.PatternValidator, i6.NgIf, i7.Calendar, i8.Table, i9.PrimeTemplate, i10.MatIcon], styles: [".positionHeading[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-weight:600;font-size:16px;color:#4a4a4a;margin-left:-14px;margin-top:20px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicPositionEditDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-basic-position-edit-details',
                templateUrl: 'basic-position-edit-details.component.html',
                styleUrls: ['basic-position-edit-details.component.scss']
            }]
    }], function () { return [{ type: BasicPositionEditDetailsService }, { type: i2$1.FileUploadLibraryService }, { type: i3.ToastrService }, { type: i1$1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: i5.FormBuilder }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class BasicPositionEditDetailsModule {
}
BasicPositionEditDetailsModule.ɵfac = function BasicPositionEditDetailsModule_Factory(t) { return new (t || BasicPositionEditDetailsModule)(); };
BasicPositionEditDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: BasicPositionEditDetailsModule });
BasicPositionEditDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PrimengLibraryModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BasicPositionEditDetailsModule, { declarations: [BasicPositionEditDetailsComponent], imports: [CommonModule,
        PrimengLibraryModule,
        ReactiveFormsModule], exports: [BasicPositionEditDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicPositionEditDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [BasicPositionEditDetailsComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule,
                    ReactiveFormsModule
                ],
                exports: [BasicPositionEditDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of basic-position-edit-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BasicPositionEditDetailsComponent, BasicPositionEditDetailsModule, BasicPositionEditDetailsService };
//# sourceMappingURL=basic-position-edit-details.js.map
